'use client';

import { Container, useModal, TypeformSnippet } from 'components/shared';
import { H2_OPT as H2, P } from '../styleConstants';
import { analytics } from 'lib/analytics/analytics';
import { useTranslations } from 'next-intl';
import styles from './MembershipComponent.module.css';

// "Request access" Typeform (default when no id is passed to the modal).
const APPLY_TYPEFORM_ID = 'n9qM0gP5';
// Dedicated "Bulk orders" Typeform.
const BULK_ORDER_TYPEFORM_ID = 'ZQX1YCca';

export const ApplyMembershipTFModal = ({
  className,
  trackingParams,
  typeformId = APPLY_TYPEFORM_ID,
  frameTitle,
}: {
  className?: string;
  typeformId?: string;
  frameTitle?: string;
  trackingParams?: {
    utm_source?: string;
    utm_medium?: string;
    utm_campaign?: string;
  };
}) => {
  const t = useTranslations('forWork');
  return (
    <div className={className ? `${styles.applyModal} ${className}` : styles.applyModal}>
      <TypeformSnippet
        typeformId={typeformId}
        frameTitle={frameTitle ?? t('membership.applyFrameTitle')}
        className={styles.typeformContainer}
        trackingParams={trackingParams}
      />
    </div>
  );
};

export const MembershipComponent = ({ className }: { className?: string }) => {
  const t = useTranslations('forWork');
  const ModalClient = useModal();

  const handleLinkClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    analytics.track(`ultrawork request access - CLICK`);
    let url = 'website';
    if (window) {
      url = window.location.hostname + window.location.pathname;
    }
    ModalClient.set(
      <ApplyMembershipTFModal
        trackingParams={{
          utm_source: url,
          utm_medium: 'ultrawork-section-2',
        }}
      />,
    );
    ModalClient.setCloseButtonTheme('light');
    ModalClient.show();
  };

  const handleBulkClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    analytics.track(`ultrawork bulk order - CLICK`);
    let url = 'website';
    if (window) {
      url = window.location.hostname + window.location.pathname;
    }
    ModalClient.set(
      <ApplyMembershipTFModal
        typeformId={BULK_ORDER_TYPEFORM_ID}
        frameTitle={t('membership.bulkOrderFrameTitle')}
        trackingParams={{
          utm_source: url,
          utm_medium: 'ultrawork-bulk-order',
        }}
      />,
    );
    ModalClient.setCloseButtonTheme('light');
    ModalClient.show();
  };

  return (
    <section className={className ? `${styles.root} ${className}` : styles.root}>
      <Container>
        <H2>{t('membership.title')}</H2>

        <P>{t('membership.description')}</P>

        <div className={styles.ctaRow}>
          <button
            type="button"
            className={`${styles.memCta} ${styles.memCtaPrimary}`}
            aria-haspopup="dialog"
            onClick={handleBulkClick}
          >
            {t('membership.bulkOrders')}
          </button>
          <button
            type="button"
            className={`${styles.memCta} ${styles.memCtaSecondary}`}
            aria-haspopup="dialog"
            onClick={handleLinkClick}
          >
            {t('membership.requestAccess')}
          </button>
        </div>
      </Container>
    </section>
  );
};
